import PropTypes from "prop-types"
import React, { useState, useEffect, useContext } from "react"

import { withRouter } from "react-router-dom"
import {
  changeLayout,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction,
} from "../../store/actions"

// Layout Related Components
import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"
import RightSidebar from "../CommonForBoth/RightSidebar"

//redux
import { useSelector, useDispatch } from "react-redux"
import { AppContext, pageContentPaddingTop } from "helpers/sf_utils"
import { bsh_isAdminUserDetailsPresent } from "helpers/sf_browser_storage_helper"
import { PRODUCT_TYPE_IDS, preloaderGif } from "helpers/sf_constants"
import { LATEST } from "common/sf_strings"
import usePlatformSettings from "hooks/usePlatformSettings"
import useNewBrandUI from "hooks/useNewBrandUI"

const SHOW_REPORTING_DATA = [
  '/analytics',
  '/dashboard',
  '/campaigns',
  '/leads',
  '/leads/detail',
  '/calls',
  'adgroups',
  '/billing',
  '/history',
  '/creatives',
  '/client-users',
  '/insurance_carriers',
  '/insurance_carriers',
  '/terms_of_services',
  '/refund_reasons',
  '/accounting/payment_terms',
  '/accounting/billing_events',
  '/admin_internal_user',
  '/admin_change_history',
  '/email-activity',
  '/report-exports',
  '/user_activity',
  '/notifications_terminal',
  '/settings',
  '/twilio_numbers',
  '/integrations/log/',
  '/admin_call_prices',
  '/admin_lead_prices',
  '/admin_lead_refunds',
  '/receipts',
  '/sf_filters',
  '/whitelabeled_brands',
  '/users',
  '/invoices',
  '/conversations',
  '/dev-dashboard',
  '/reporting-consistency',
  '/dms-dashboard',
  '/rules-dashboard',
]

const Layout = props => {
  const dispatch = useDispatch()
  const { isClicksProductEnabled, isMetricsEnabled, isPixelConversionSettingsEnabled, isProfilesEnabled, isSourceSettingsEnabled } = usePlatformSettings();
  const {
    isPreloader,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    showRightSidebar,
    leftSideBarTheme,
    current_role_permissions_state,
    current_admin_user,
    current_admin_user_permissions,
    campaigns,
    current_brand,
    current_account,
    admin_notifications,
    features_flags_loading
  } = useSelector(state => ({
    isPreloader: state.Layout.isPreloader,
    leftSideBarThemeImage: state.Layout.leftSideBarThemeImage,
    leftSideBarType: state.Layout.leftSideBarType,
    layoutWidth: state.Layout.layoutWidth,
    topbarTheme: state.Layout.topbarTheme,
    showRightSidebar: state.Layout.showRightSidebar,
    leftSideBarTheme: state.Layout.leftSideBarTheme,
    current_role_permissions_state: state.Role.current_role_permissions_state,
    current_admin_user: state.LoginAdminUser.current_user,
    current_admin_user_permissions: state.LoginAdminUser.current_admin_user_permissions,
    campaigns: state.Campaign.campaigns,
    current_brand: state.Brands.current_brand,
    current_account: state.accounts.current_account,
    admin_notifications: state.AdminNotifications.admin_notifications,
    features_flags_loading: state.featuresFlags.loading,
  }))

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  const show_rtb_brand_ui_changes = useNewBrandUI()

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile))
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile))
    }
  }
  const { isSidebarMinimized, setIsSidebarMinimized } = useContext(AppContext);
  //hides right sidebar on body click
  const hideRightbar = event => {
    var rightbar = document.getElementById("right-bar")
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false))
    }
  }

  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    //TODO: REVIEW This later
    // Having this event listener event doesnt allow the select all
    // behavior of the bootstrap table. Same issue is present
    // in the Skote theme, most likely a bug in the theme
    //document.body.addEventListener("click", hideRightbar, true)

    if (isPreloader === true) {
      document.getElementById("preloader").style.display = "block"
      document.getElementById("status").style.display = "block"

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none"
        document.getElementById("status").style.display = "none"
      }, 2500)
    } else {
      document.getElementById("preloader").style.display = "none"
      document.getElementById("status").style.display = "none"
    }
  }, [isPreloader])

  const [leadsCampaigns, setLeadsCampaigns] = useState(false);
  const [callsCampaigns, setCallsCampaigns] = useState(false);
  const [quoteFunnelsCampaigns, setQuoteFunnelsCampaigns] = useState(false)

  useEffect(() => {
    let campaignsList = []
    if (campaigns && current_brand && current_account) {
      campaignsList = show_rtb_brand_ui_changes ? campaigns : campaigns.filter((campaign) => campaign.brand_id.toString() === current_brand.id.toString());
      const callsCampaigns = campaignsList.filter(campaign => campaign.product_type_id === PRODUCT_TYPE_IDS.CALLS);
      setCallsCampaigns(callsCampaigns.length > 0 && current_account.call_details_enabled);
      const leadsCampaigns = campaignsList.filter(campaign => campaign.product_type_id === PRODUCT_TYPE_IDS.LEADS);
      setLeadsCampaigns(leadsCampaigns.length > 0);
      const quoteFunnelsCampaigns = campaignsList.filter(campaign => campaign.product_type_id === PRODUCT_TYPE_IDS.QUOTE_FUNNELS);
      setQuoteFunnelsCampaigns(quoteFunnelsCampaigns.length > 0);
    }
  }, [campaigns,show_rtb_brand_ui_changes]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    dispatch(changeLayout("vertical"))
  }, [dispatch])

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme))
    }
  }, [leftSideBarTheme, dispatch])

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage))
    }
  }, [leftSideBarThemeImage, dispatch])

  useEffect(() => {
    if (layoutWidth) {
      setIsSidebarMinimized(false)
      dispatch(changeLayoutWidth(layoutWidth))
    }
  }, [layoutWidth, dispatch])

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType))
    }
  }, [leftSideBarType, dispatch])

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme))
    }
  }, [topbarTheme, dispatch])

  let isAdminLayout = false;

  if (bsh_isAdminUserDetailsPresent() && !localStorage.getItem('authUser')) {
    isAdminLayout = true;
  }


  // Calculate the padding top based on notification bar
  const notificationBarDiv = document.getElementById('notification-bar');
  // Check if the Notification div element exists
  if (notificationBarDiv) {
    // Calculate the height of the Notification div element
    const notificationBarHeight = notificationBarDiv.clientHeight;

    // Calculate the height of the Page Content Wrapper div element
    const pageContentHeight = pageContentPaddingTop + notificationBarHeight;

    // Set the height of the Page Content Wrapper div element
    const pageContentDiv = document.getElementById('page-content-wrapper');

    if (pageContentDiv) {
      pageContentDiv.style.paddingTop = `${pageContentHeight}px`;
    }
  } else {
  }

  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          {/* NOTE: Uncomment the following div to use the spinner-chase */}
          {/* <div className="spinner-chase">
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
            <div className="chase-dot" />
          </div> */}
          <img src={preloaderGif} alt="logo" height="80" />
        </div>
      </div>

      <div id="layout-wrapper">
        <Header isAdminLayout={isAdminLayout} toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
          isAdminLayout={isAdminLayout}
          rolePermissions={current_role_permissions_state}
          adminRolePermissions={(current_admin_user && current_admin_user_permissions) || null}
          currentAdminUser={current_admin_user}
          isPlatformSettingFeatures={{ isClicksProductEnabled, isMetricsEnabled, isPixelConversionSettingsEnabled, isProfilesEnabled, isSourceSettingsEnabled }}
          campaigns={{ call: callsCampaigns, lead: leadsCampaigns, quote_funnels: quoteFunnelsCampaigns }}
          loadings={features_flags_loading}
          adminNotifications={admin_notifications}
        />
        <div className="main-content my-3">{props.children}</div>
        {window.location.href.includes('/creatives/edit') || window.location.href.includes('/creatives/create') ? '' :
          <Footer
            showReportingData={SHOW_REPORTING_DATA.some(element => window.location.href.includes(element))}
            termsOfServiceVersion={current_account?.terms_of_service_id || LATEST}
          />
        }
      </div>
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  )
}

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.object,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
}

export default withRouter(Layout)
